import React from 'react';

function Service() {
  return (
    <section className="services wrap" id="hash-services">
      <div className="flex-box">
        <div className="flex-left">
          <div className="wrap-title">
            <h2 lang="en">Services</h2>
            <p>공유디자이너랩 시설이용</p>
          </div>
        </div>
        <div className="flex-right">
          <div className="flex-box">
            <dl>
              <dt>종이 및 프린팅 무료</dt>
              <dd>1팀당 A4 20장, 특수용지 10장 제공</dd>
              <dd>레이저프린트 (A3사이즈까지)</dd>
              <dd>재단기</dd>
              <dd>코팅기</dd>
            </dl>
            <dl>
              <dt>디자인 서적 및 작업공간 공유</dt>
              <dd>드로잉 도구</dd>
              <dd>디자인 서적</dd>
              <dd>지류 샘플북</dd>
              <dd>라운지 작업공간</dd>
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Service;
